// import reactUseCookie from "react-use-cookie";

import {apiUrl} from "../api/baseURL";

// import venezialogo from "../../images/icons/veneziaOfficeLogo.png";

export const FEA_MANAGERS_POSITIONS_IDS = Object.freeze([1, 3, 7]);

export const ADVANCE_PROCENT = 70;

export const USER_ROLES = Object.freeze({BRAND_MANAGER: 1, MANAGER: 2, SUPER_USER: 3, TOP_MANAGER: 6});

export const findOutRole = user => {
  return user?.role?.roleId;
};

export const CO_STATUSES = Object.freeze({
  CREATED: 1,
  ACTIVE: 2,
  DONE: 3,
  ONPAYMENT: 4,
  PAIDINADVANCED: 5,
  MAIN: 6,
  PAID: 7,
});

export const COF_STATES = Object.freeze({
  HAS_DIRECTIVE: "✓",
  FROZEN: "❄️",
  PAID: "💸",
});

export const PAYMENT_STATES = Object.freeze({
  HAS_DIRECTIVE: "💼",
  PAID: "💸",
});

export const SALE_TYPES = Object.freeze(["Fabrication", "Packaging", "Roll", "Sack", "Jar"]);

export const UNITS = Object.freeze({PIECES: 1, SQ_M: 2, KG: 3, LOADING_M: 4, PACKAGE: 5, ROLL: 6, SACK: 7, CAN: 8});

export const IT_MANAGERS_IDS = Object.freeze([2, 3, 33, 42, 43, 44, 45, 46]);
export const findIfUserIsITManager = user => IT_MANAGERS_IDS.includes(user?.id);

export const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const findIfEmailIsValid = email => !!email && email.match(isValidEmail);

// export const ORG_STRUCTURES_INFO = Object.freeze({
//   //NOK
//   1: {
//     cite: "venezia.com.ua",
//     city: "Kyiv, Ukraine",
//     street: "Velyka Vasylkivska St., 13/1",
//     logo: venezialogo,
//   },
// });

export const addedFileSymbol = "📎";
export const addedFileRowSymbol = "✓";

//for pdfMaker to adjust big length cells (если в колонке, например описания, очень много символов, то этот рядок не отображался и был белый пробел до следующей страницы)
export const cellAdapt = {
  A4: cellLength => {
    if (cellLength < 500) {
      return {sliceTo: cellLength, fontSize: 7};
    }
    if (cellLength < 700) {
      return {sliceTo: cellLength, fontSize: 6.5};
    }
    if (cellLength < 900) {
      return {sliceTo: cellLength, fontSize: 5.5};
    }

    return {sliceTo: 1200, fontSize: 5};
  },
  A3: cellLength => {
    if (cellLength < 900) {
      return {sliceTo: cellLength, fontSize: 7};
    }
    if (cellLength < 1200) {
      return {sliceTo: cellLength, fontSize: 6};
    }
    if (cellLength < 1600) {
      return {sliceTo: cellLength, fontSize: 5};
    }

    return {sliceTo: 1800, fontSize: 4};
  },
};

export const getImageSize = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      resolve({width: img.width, height: img.height, widthHeightCoef: img.width / img.height});
    };

    img.onerror = reject;
  });
};

export const imgcellRender = value => {
  var imgs = value.getValue();
  if (imgs) {
    return (
      <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
        <div key={imgs} style={{position: "relative"}}>
          <img src={apiUrl + "/" + imgs} alt={imgs} style={{width: "5em", height: "5em", marginRight: "2px"}} />
        </div>
      </div>
    );
  }
};

export const imgCellRenderByUrl = url => {
  if (!url) return <></>;

  return (
    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
      <div key={url} style={{position: "relative"}}>
        <img src={apiUrl + "/" + url} alt={url} style={{width: "5em", height: "5em", marginRight: "2px"}} />
      </div>
    </div>
  );
};

export const pdfStyles = {
  tableHeader: {
    bold: true,
    fontSize: 10,
    color: "black",
    alignment: "center",
  },
  cell: {
    fontSize: 9,
    color: "black",
    alignment: "left",
  },
  justy: {
    alignment: "center",
  },
  nestedTable: {
    margin: [20, 0, 0, 0],
    alignment: "left", // Убираем отступы внутри ячейки с вложенной таблицей
  },
  header: {
    bold: true,
    fontSize: 9,
  },
  headerH1: {
    bold: true,
    fontSize: 16,
    alignment: "center",
    margin: [0, 10, 0, 0],
  },
  headerH2: {
    bold: true,
    fontSize: 14,
    alignment: "center",
    margin: [0, 10, 0, 5],
  },
  simpletext: {
    margin: [0, 5, 0, 0],
  },
  emptyRow: {
    lineHeight: 2,
    color: "white",
  },
};

export class LocalStorageManager {
  constructor(name) {
    this.name = name;
    try {
      this.item = JSON.parse(localStorage.getItem(name));
    } catch (error) {
      console.error(error);
    }
  }

  getItem() {
    return JSON.parse(localStorage.getItem(this.name));
  }

  setItem(item) {
    localStorage.setItem(this.name, JSON.stringify(item));
  }

  clearItem() {
    this.name = null;
    localStorage.setItem(this.name, null);
  }
}

export class SessionStorageManager {
  constructor(name) {
    this.name = name;
  }

  getItem() {
    try {
      return JSON.parse(sessionStorage.getItem(this.name));
    } catch (error) {
      console.error(error);
    }
  }

  setItem(item) {
    try {
      sessionStorage.setItem(this.name, JSON.stringify(item));
    } catch (error) {
      console.error(error);
    }
  }

  clearItem() {
    try {
      this.name = null;
      sessionStorage.setItem(this.name, null);
    } catch (error) {
      console.error(error);
    }
  }
}

export const findIfTokenExpired = () => {
  const tokenLifespan = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
  // const tokenLifespan = 5 * 1000;

  const loginTimeManager = new LocalStorageManager("login_time");
  const loginTime = loginTimeManager.getItem();

  return !loginTime || Date.now() > +loginTime + tokenLifespan;
};

// export class CookieManager {
//   constructor(name, options = {}) {
//     this.name = name;
//     this.options = options;

//     const [cookie, setCookie, removeCookie] = reactUseCookie(name, "0", this.options);
//     this.cookie = cookie;
//     this.setCookie = setCookie;
//     this.removeCookie = removeCookie;
//   }

//   getItem() {
//     return this.cookie;
//   }

//   setItem(item) {
//     this.setCookie(item, this.options);
//   }

//   clearItem() {
//     this.name = null;
//     this.removeCookie();
//   }
// }

export const ERROR = Object.freeze({
  TOKEN: "No token or token expired",
  CANCELED: "ERR_CANCELED", //canceled request via AbortController
});
export const formDocNumberFromFileName = fileName => {
  return fileName?.slice(0, fileName.lastIndexOf("."));
};

export const EUR_CURRENCY_ID = 978;

export const formFileUrlFromFile = file => `${file.fileUrl}${file.deletedAt ? "|DELETED" : ""}`;
export const formFileUrlFromFileString = file => file?.split("|DELETED")?.[0];

export const print = url => {
  if (!url) return;

  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // Скрываем от пользователя
  document.body.appendChild(iframe);

  // Пишем в iframe HTML с картинкой
  iframe.contentDocument.write(`
    <html>
      <body style="margin:0;">
        <img src="${url}" style="width:100%;" onload="window.print();">
      </body>
    </html>
  `);
  iframe.contentDocument.close();

  // Удаляем iframe после того, как окно печати закроется
  iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
};
